// OOTD Instagram Gallery - Fixed version
// 确保脚本只加载一次
if (!window.ootdInstagramInitialized) {
  window.ootdInstagramInitialized = true;
  
  console.log('OOTD Instagram Gallery script loading...');
  
  // 全局错误处理
  window.addEventListener('error', function(e) {
    console.error('OOTD Instagram Error:', e.error);
  });
  
  // 主初始化函数
  window.initializeInstagramGallery = function() {
    try {
      console.log('OOTD Instagram Gallery initializing...');
      
      // 等待一小段时间确保DOM完全加载
      setTimeout(initGallery, 300);
    } catch (error) {
      console.error('Failed to initialize Instagram gallery:', error);
    }
  };
  
  // 自动初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initializeInstagramGallery, 300);
    });
  } else {
    setTimeout(initializeInstagramGallery, 300);
  }
  
  function initGallery() {
    const section = document.querySelector('.ootd-instagram-section');
    if (!section) {
      console.warn('OOTD Instagram section not found');
      return;
    }
    
    console.log('OOTD Instagram section found, initializing...');
    
    const modalTemplate = document.getElementById('ootd-instagram-modal-template');
    const loadMoreButton = section.querySelector('.ootd-load-more');
    const loadMoreText = loadMoreButton ? loadMoreButton.querySelector('.load-more-text') : null;
    
    const totalItems = parseInt(section.dataset.totalItems) || 0;
    const itemsPerLoad = 10; // 固定每次加载10个
    let loadedItems = parseInt(section.dataset.loadedItems) || itemsPerLoad;
    
    // Modal相关变量
    let modalOverlay = null;
    let modalImage = null;
    let modalVideo = null;
    let modalHandle = null;
    let modalCaption = null;
    let modalAvatar = null;
    let modalProducts = null;
    let closeBtn = null;
    let prevBtns = null;
    let nextBtns = null;
    let backToTopBtn = null;
    
    // 存储所有可见项目的数据
    let allVisibleItems = [];
    let currentItemIndex = 0;
    
    // 状态标志
    let isModalOpen = false;
    
    // 事件处理函数
    let keyboardHandler = null;
    let resizeHandler = null;
    let scrollHandler = null;
    
    // 滚动位置记录
    let scrollPosition = 0;
    
    // 修复：初始化加载更多功能 - 每次固定加载10个
    function initLoadMore() {
      if (!loadMoreButton) return;
      
      console.log('Initializing load more button');
      
      // 如果所有项目都已显示，隐藏加载更多按钮
      if (loadedItems >= totalItems) {
        loadMoreButton.style.display = 'none';
      }
      
      loadMoreButton.addEventListener('click', function(e) {
        console.log('Load more button clicked');
        e.preventDefault();
        e.stopPropagation();
        
        if (loadedItems >= totalItems) {
          loadMoreButton.style.display = 'none';
          return;
        }
        
        // 显示加载状态 - 使用CSS动画
        loadMoreButton.classList.add('loading');
        if (loadMoreText) loadMoreText.style.display = 'none';
        loadMoreButton.disabled = true;
        
        // 模拟加载延迟
        setTimeout(function() {
          // 显示下一批项目 - 固定加载10个
          const hiddenItems = document.querySelectorAll('.ootd-item-hidden');
          console.log(`Found ${hiddenItems.length} hidden items`);
          
          // 固定显示10个或剩余的所有项目
          const itemsToShow = Math.min(10, hiddenItems.length);
          console.log(`Will show ${itemsToShow} items`);
          
          for (let i = 0; i < itemsToShow; i++) {
            if (hiddenItems[i]) {
              hiddenItems[i].classList.remove('ootd-item-hidden');
              console.log(`Showing hidden item ${i + 1}/${itemsToShow}`);
            }
          }
          
          loadedItems += itemsToShow;
          section.dataset.loadedItems = loadedItems;
          console.log(`Now loaded ${loadedItems} out of ${totalItems} items`);
          
          // 更新按钮状态
          loadMoreButton.classList.remove('loading');
          if (loadMoreText) {
            loadMoreText.style.display = 'inline';
            loadMoreText.textContent = 'Load More'; // 保持按钮文本不变
          }
          loadMoreButton.disabled = false;
          
          // 如果所有项目都已加载，隐藏按钮
          if (loadedItems >= totalItems) {
            loadMoreButton.style.display = 'none';
            console.log('All items loaded, hiding load more button');
          }
          
          // 重新绑定点击事件给新显示的项目
          bindItemClickEvents();
          
        }, 300);
      });
      
      // 初始化按钮文本 - 保持简单文本
      if (loadMoreText) {
        loadMoreText.textContent = 'Load More';
      }
    }
    
    // 修复：使用事件委托绑定项目点击事件
    function bindItemClickEvents() {
      console.log('Binding item click events using event delegation');
      
      // 移除旧的事件监听器
      section.removeEventListener('click', handleItemClickDelegated);
      
      // 添加新的事件监听器（事件委托）
      section.addEventListener('click', handleItemClickDelegated);
      
      // 直接给现有的按钮添加事件
      const buttons = section.querySelectorAll('.ootd-item-button');
      buttons.forEach(button => {
        button.removeEventListener('click', handleItemClick);
        button.addEventListener('click', handleItemClick);
      });
    }
    
    // 事件委托处理函数
    function handleItemClickDelegated(e) {
      // 检查是否点击了ootd-item-button或其子元素
      const button = e.target.closest('.ootd-item-button');
      if (button) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Item clicked via delegation, opening modal');
        openModal(button);
      }
    }
    
    // 处理项目点击
    function handleItemClick(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Item clicked directly, opening modal');
      openModal(this);
    }
    
    // 获取所有可见项目的DOM元素
    function getAllVisibleItems() {
      return Array.from(document.querySelectorAll('.ootd-item:not(.ootd-item-hidden)'));
    }
    
    // 更新导航按钮状态
    function updateNavButtons() {
      if (!prevBtns || !nextBtns) return;
      
      const prevDisabled = currentItemIndex === 0;
      const nextDisabled = currentItemIndex === allVisibleItems.length - 1;
      
      prevBtns.forEach(btn => {
        btn.disabled = prevDisabled;
        btn.style.opacity = prevDisabled ? '0.3' : '0.9';
        btn.style.pointerEvents = prevDisabled ? 'none' : 'auto';
      });
      
      nextBtns.forEach(btn => {
        btn.disabled = nextDisabled;
        btn.style.opacity = nextDisabled ? '0.3' : '0.9';
        btn.style.pointerEvents = nextDisabled ? 'none' : 'auto';
      });
    }
    
    // 导航到指定项目
    function navigateToItem(index) {
      if (index < 0 || index >= allVisibleItems.length) return;
      
      currentItemIndex = index;
      const clickedItem = allVisibleItems[index];
      loadModalContent(clickedItem.dataset);
      updateNavButtons();
    }
    
    // 添加播放按钮覆盖层函数
    function addPlayButtonOverlay() {
      // 移除现有的播放按钮
      const existingOverlay = document.querySelector('.ootd-video-play-overlay');
      if (existingOverlay) {
        existingOverlay.remove();
      }
      
      // 只在移动端添加播放按钮
      if (window.innerWidth > 1024) return;
      
      // 创建播放按钮覆盖层
      const playOverlay = document.createElement('div');
      playOverlay.className = 'ootd-video-play-overlay';
      
      playOverlay.innerHTML = `
        <div style="
          width: 80px;
          height: 80px;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.2s ease;
        ">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="white">
            <path d="M8 5v14l11-7z"/>
          </svg>
        </div>
      `;
      
      playOverlay.addEventListener('click', function(e) {
        e.stopPropagation();
        modalVideo.play().then(() => {
          playOverlay.style.display = 'none';
          modalVideo.muted = true; // 保持静音
        }).catch(error => {
          console.log('Manual play failed:', error);
        });
      });
      
      const mediaWrapper = document.querySelector('.ootd-modal-media-wrapper');
      if (mediaWrapper) {
        mediaWrapper.appendChild(playOverlay);
      }
    }
    
    // 处理视频播放事件
    function setupVideoEvents() {
      if (!modalVideo) return;
      
      // 播放时添加playing类
      modalVideo.addEventListener('play', function() {
        this.classList.add('playing');
      });
      
      // 暂停时移除playing类
      modalVideo.addEventListener('pause', function() {
        this.classList.remove('playing');
      });
      
      // 鼠标移入视频区域时显示控件
      modalVideo.addEventListener('mouseenter', function() {
        this.classList.add('hovering');
      });
      
      // 鼠标移出视频区域时隐藏控件
      modalVideo.addEventListener('mouseleave', function() {
        this.classList.remove('hovering');
      });
      
      // 点击视频时切换播放/暂停
      modalVideo.addEventListener('click', function(e) {
        if (e.target === this) {
          if (this.paused) {
            this.play();
          } else {
            this.pause();
          }
        }
      });
      
      // 监听全屏变化
      document.addEventListener('fullscreenchange', handleFullscreenChange);
      document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.addEventListener('mozfullscreenchange', handleFullscreenChange);
      document.addEventListener('MSFullscreenChange', handleFullscreenChange);
    }
    
    // 处理全屏变化
    function handleFullscreenChange() {
      if (!modalVideo) return;
      
      const isFullscreen = document.fullscreenElement || 
                          document.webkitFullscreenElement || 
                          document.mozFullScreenElement || 
                          document.msFullscreenElement;
      
      if (!isFullscreen) {
        // 退出全屏后恢复视频控件
        modalVideo.controls = true;
      }
    }
    
    // 切换全屏
    function toggleFullscreen() {
      if (!modalVideo) return;
      
      if (!document.fullscreenElement && 
          !document.webkitFullscreenElement && 
          !document.mozFullScreenElement && 
          !document.msFullscreenElement) {
        // 进入全屏
        if (modalVideo.requestFullscreen) {
          modalVideo.requestFullscreen();
        } else if (modalVideo.webkitRequestFullscreen) {
          modalVideo.webkitRequestFullscreen();
        } else if (modalVideo.mozRequestFullScreen) {
          modalVideo.mozRequestFullScreen();
        } else if (modalVideo.msRequestFullscreen) {
          modalVideo.msRequestFullscreen();
        }
      } else {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }
    
    // 加载模态框内容
    function loadModalContent(data) {
      console.log('Loading modal content:', data);
      
      const isVideo = data.isVideo === 'true' && data.videoUrl;
      
      // 图片/视频
      if (isVideo) {
        modalImage.style.display = 'none';
        modalVideo.src = data.videoUrl;
        modalVideo.style.display = 'block';
        modalVideo.muted = true; // 默认静音
        modalVideo.autoplay = true; // 开启自动播放
        modalVideo.playsInline = true;
        modalVideo.controls = true;
        modalVideo.controlsList = 'nodownload';
        modalVideo.setAttribute('playsinline', 'true');
        modalVideo.setAttribute('webkit-playsinline', 'true');
        
        // 设置视频事件
        setupVideoEvents();
        
        // 监听视频加载完成
        modalVideo.onloadeddata = function() {
          console.log('Video loaded, attempting to play');
          
          // 尝试播放视频（静音状态下）
          const playPromise = modalVideo.play();
          
          if (playPromise !== undefined) {
            playPromise.then(() => {
              console.log('Video autoplay successful (muted)');
              // 保持静音状态
            }).catch(error => {
              console.log('Autoplay failed, showing controls:', error);
              // 如果自动播放失败，显示控件让用户手动播放
              modalVideo.controls = true;
              
              // 添加播放按钮覆盖层
              addPlayButtonOverlay();
            });
          }
        };
        
        // 处理全屏按钮点击
        modalVideo.addEventListener('fullscreenchange', function() {
          console.log('Fullscreen changed');
        });
        
        modalVideo.load();
        
      } else {
        modalVideo.style.display = 'none';
        modalVideo.pause();
        modalVideo.src = '';
        modalImage.style.display = 'block';
        modalImage.src = data.imageUrl;
      }
      
      // 用户信息
      modalHandle.textContent = data.handle || '@ootd';
      
      // 描述文字
      if (data.caption && data.caption.trim() !== '' && data.caption !== 'Share your style with #OOTD') {
        modalCaption.textContent = data.caption;
        modalCaption.style.display = 'block';
      } else {
        modalCaption.style.display = 'none';
      }
      
      // 头像
      let avatarUrl = data.avatarUrl;
      if (!avatarUrl || avatarUrl.includes('no-image')) {
        avatarUrl = 'https://via.placeholder.com/40x40?text=OOTD';
      }
      modalAvatar.src = avatarUrl;
      modalAvatar.onerror = function() {
        this.src = 'https://via.placeholder.com/40x40?text=OOTD';
      };
      
      // 商品列表
      modalProducts.innerHTML = '';
      try {
        const products = JSON.parse(data.products || '[]');
        if (products.length > 0) {
          products.forEach(p => {
            const productDiv = document.createElement('div');
            productDiv.className = 'ootd-modal-product';
            productDiv.innerHTML = `
              <div class="ootd-modal-product-image">
                <img src="${p.image}" alt="${p.title}" loading="lazy">
              </div>
              <div class="ootd-modal-product-info">
                <div class="ootd-modal-product-title">${p.title}</div>
                <div class="ootd-modal-product-price">${p.price}</div>
                <div class="ootd-modal-product-actions">
                  <a href="${p.url}" class="ootd-product-button shop-now">Shop Now</a>
                </div>
              </div>
            `;
            
            modalProducts.appendChild(productDiv);
          });
        } else {
          modalProducts.innerHTML = '<div class="no-products">No products associated with this post.</div>';
        }
      } catch (err) {
        console.error('Error parsing products:', err);
        modalProducts.innerHTML = '<div class="no-products">Error loading products.</div>';
      }
    }
    
    // 检查窗口大小并更新箭头显示
    function checkArrowsVisibility() {
      if (!modalOverlay || !isModalOpen) return;
      
      const isMobile = window.innerWidth <= 1024;
      const desktopArrows = modalOverlay.querySelectorAll('.desktop-arrow');
      const mobileArrows = modalOverlay.querySelectorAll('.mobile-arrow');
      
      if (isMobile) {
        desktopArrows.forEach(arrow => {
          arrow.style.display = 'none';
        });
        mobileArrows.forEach(arrow => {
          arrow.style.display = 'flex';
        });
      } else {
        desktopArrows.forEach(arrow => {
          arrow.style.display = 'flex';
        });
        mobileArrows.forEach(arrow => {
          arrow.style.display = 'none';
        });
      }
    }
    
    // 移动端滚动处理
    function handleMobileScroll() {
      if (!modalOverlay || !backToTopBtn) return;
      
      if (modalOverlay.scrollTop > 300) {
        backToTopBtn.style.display = 'flex';
        backToTopBtn.classList.add('show');
      } else {
        backToTopBtn.style.display = 'none';
        backToTopBtn.classList.remove('show');
      }
    }
    
    // 回到顶部功能
    function scrollToTop() {
      if (!modalOverlay) return;
      
      modalOverlay.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    
    // 处理键盘事件
    function handleKeyDown(e) {
      if (!isModalOpen) return;
      
      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        if (currentItemIndex > 0) {
          navigateToItem(currentItemIndex - 1);
        }
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        if (currentItemIndex < allVisibleItems.length - 1) {
          navigateToItem(currentItemIndex + 1);
        }
      } else if (e.key === 'f' || e.key === 'F') {
        // F键切换全屏
        e.preventDefault();
        toggleFullscreen();
      }
    }
    
    // 处理窗口resize事件
    function handleResize() {
      checkArrowsVisibility();
    }
    
    // 初始化模态框
    function initModal() {
      console.log('Initializing modal');
      
      // 如果模态框已经存在，先完全移除
      const existingModal = document.querySelector('.ootd-modal-overlay');
      if (existingModal) {
        existingModal.remove();
      }
      
      // 克隆模板
      const clone = modalTemplate.content.cloneNode(true);
      modalOverlay = clone.querySelector('.ootd-modal-overlay');
      
      // 添加到页面
      document.body.appendChild(modalOverlay);
      
      // 获取modal元素
      modalImage = modalOverlay.querySelector('.ootd-modal-image');
      modalVideo = modalOverlay.querySelector('.ootd-modal-video');
      modalHandle = modalOverlay.querySelector('.ootd-modal-handle');
      modalCaption = modalOverlay.querySelector('.ootd-modal-caption');
      modalAvatar = modalOverlay.querySelector('.ootd-modal-avatar');
      modalProducts = modalOverlay.querySelector('.ootd-modal-products-list');
      backToTopBtn = modalOverlay.querySelector('.ootd-modal-back-to-top');
      
      // 获取所有箭头按钮
      prevBtns = modalOverlay.querySelectorAll('.ootd-modal-prev');
      nextBtns = modalOverlay.querySelectorAll('.ootd-modal-next');
      closeBtn = modalOverlay.querySelector('.ootd-modal-close');
      
      console.log('Modal elements initialized');
      
      // 绑定事件
      closeBtn.addEventListener('click', closeModal);
      
      // 回到顶部按钮
      backToTopBtn.addEventListener('click', scrollToTop);
      
      // 导航按钮事件
      prevBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          if (currentItemIndex > 0) {
            navigateToItem(currentItemIndex - 1);
          }
        });
      });
      
      nextBtns.forEach(btn => {
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          if (currentItemIndex < allVisibleItems.length - 1) {
            navigateToItem(currentItemIndex + 1);
          }
        });
      });
      
      // 点击overlay关闭
      modalOverlay.addEventListener('click', function(e) {
        if (e.target === modalOverlay) {
          closeModal();
        }
      });
      
      // 移动端滚动事件
      scrollHandler = handleMobileScroll.bind(this);
      modalOverlay.addEventListener('scroll', scrollHandler);
      
      console.log('Modal initialization complete');
    }
    
    // 打开模态框
    function openModal(clickedButton) {
      console.log('Opening modal');
      
      // 记录当前滚动位置
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      // 获取所有可见项目
      allVisibleItems = getAllVisibleItems();
      
      // 找到当前点击的项目索引
      const clickedItem = clickedButton.closest('.ootd-item');
      currentItemIndex = allVisibleItems.indexOf(clickedItem);
      
      if (currentItemIndex === -1) {
        console.error('Clicked item not found in visible items');
        return;
      }
      
      const data = clickedItem.dataset;
      console.log('Item data:', data);
      
      // 初始化模态框（如果需要）
      if (!modalOverlay) {
        initModal();
      }
      
      // 加载内容
      loadModalContent(data);
      
      // 更新导航按钮状态
      updateNavButtons();
      
      // 检查箭头显示
      checkArrowsVisibility();
      
      // 显示模态框
      modalOverlay.style.display = 'flex';
      setTimeout(() => {
        modalOverlay.classList.add('active');
        
        // 只在移动端添加滚动锁定
        if (window.innerWidth <= 1024) {
          document.body.classList.add('ootd-modal-open');
        }
        
        isModalOpen = true;
      }, 10);
      
      // 绑定键盘事件
      keyboardHandler = handleKeyDown.bind(this);
      document.addEventListener('keydown', keyboardHandler);
      
      // 绑定resize事件
      resizeHandler = handleResize.bind(this);
      window.addEventListener('resize', resizeHandler);
      
      // 初始滚动到顶部
      setTimeout(() => {
        modalOverlay.scrollTop = 0;
        if (backToTopBtn) {
          backToTopBtn.style.display = 'none';
          backToTopBtn.classList.remove('show');
        }
      }, 100);
      
      console.log('Modal opened successfully');
    }
    
    // 关闭模态框
    function closeModal() {
      console.log('Closing modal');
      
      if (!modalOverlay) return;
      
      // 清理播放按钮覆盖层
      const playOverlay = document.querySelector('.ootd-video-play-overlay');
      if (playOverlay) {
        playOverlay.remove();
      }
      
      // 隐藏模态框
      modalOverlay.classList.remove('active');
      setTimeout(() => {
        modalOverlay.style.display = 'none';
        document.body.classList.remove('ootd-modal-open');
        isModalOpen = false;
        
        // 恢复滚动位置
        window.scrollTo(0, scrollPosition);
      }, 300);
      
      // 暂停视频
      if (modalVideo) {
        modalVideo.pause();
        modalVideo.currentTime = 0;
        modalVideo.classList.remove('playing');
        modalVideo.classList.remove('hovering');
      }
      
      // 移除全屏事件监听
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
      
      // 退出全屏（如果正在全屏）
      if (document.fullscreenElement || 
          document.webkitFullscreenElement || 
          document.mozFullScreenElement || 
          document.msFullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
      
      // 移除事件监听
      if (keyboardHandler) {
        document.removeEventListener('keydown', keyboardHandler);
        keyboardHandler = null;
      }
      
      if (resizeHandler) {
        window.removeEventListener('resize', resizeHandler);
        resizeHandler = null;
      }
      
      if (scrollHandler) {
        modalOverlay.removeEventListener('scroll', scrollHandler);
        scrollHandler = null;
      }
      
      // 重置状态
      currentItemIndex = 0;
      
      console.log('Modal closed successfully');
    }
    
    // 初始化
    console.log('Initializing OOTD Instagram Gallery');
    initLoadMore();
    bindItemClickEvents(); // 绑定点击事件
    
    console.log('OOTD Instagram Gallery initialized successfully');
  }
}